import { formatDateTime } from '../utils/dates.ts'
import React from 'react'
import { Link } from 'react-router-dom'
import JobStatusBadge from './JobStatusBadge.tsx'

interface RecentJobsProps {
  jobs: any[]
}

export default function RecentJobs({ jobs }: RecentJobsProps) {
  return (
    <div className='card'>
      <div className='card-header'>
        <h3 className='text-lg leading-6 font-medium text-gray-900 dark:text-gray-300'>
          Recent Jobs
        </h3>
      </div>
      <div className='card-body'>
        {jobs.length === 0 ? (
          <div className='text-center py-6'>
            <p className='text-sm text-gray-500'>No recent jobs</p>
            <div className='mt-4'>
              <Link to='/jobs/create' className='btn-primary'>
                Create First Job
              </Link>
            </div>
          </div>
        ) : (
          <div className='flow-root'>
            <ul className='-my-5 divide-y divide-gray-200'>
              {jobs.map((job) => (
                <li key={job.id} className='py-4'>
                  <div className='flex items-center space-x-4'>
                    <div className='flex-shrink-0'>
                      <JobStatusBadge status={job.status} />
                    </div>
                    <div className='flex-1 min-w-0'>
                      <p className='text-sm font-medium text-gray-900 truncate dark:text-gray-300'>
                        {job.state} - {job.keywords.length} keywords
                      </p>
                      <p className='text-sm text-gray-500 dark:text-gray-300'>
                        {formatDateTime(job.created_at)}
                      </p>
                    </div>
                    <div className='flex-shrink-0 text-sm text-gray-500 dark:text-gray-300'>
                      {job.total_stores > 0 && (
                        <span>{job.total_stores} stores</span>
                      )}
                    </div>
                    <div className='flex-shrink-0'>
                      <Link
                        to={`/jobs/${job.id}`}
                        className='text-blue-600 hover:text-blue-500 text-sm font-medium'
                      >
                        View
                      </Link>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className='mt-6'>
          <Link
            to='/jobs'
            className='w-full flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50'
          >
            View all jobs
          </Link>
        </div>
      </div>
    </div>
  )
}





